import { render, staticRenderFns } from "./ClosingReasonsReports.vue?vue&type=template&id=022fc499&scoped=true&"
import script from "./ClosingReasonsReports.vue?vue&type=script&lang=js&"
export * from "./ClosingReasonsReports.vue?vue&type=script&lang=js&"
import style0 from "./ClosingReasonsReports.vue?vue&type=style&index=0&id=022fc499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022fc499",
  null
  
)

export default component.exports